import { List, RefreshButton } from "@pankod/refine-antd";
import { useInvalidate } from "@pankod/refine-core";
import { ResourceList } from "common/resource-list/ResourceList";
import {
  bcTransactionListProps,
  bcTransactionListSearchProps,
} from "./BcTransactionInterfaces";

export const BcTransactionList: React.FC = () => {
  const invalidate = useInvalidate();
  const refreshList = () => {
    invalidate({ resource: "bc-transactions", invalidates: ["list"] });
  };

  return (
    <List
      headerButtons={
        <RefreshButton
          onClick={() => {
            refreshList();
          }}
        ></RefreshButton>
      }
    >
      <ResourceList
        listProps={bcTransactionListProps}
        listSearchProps={bcTransactionListSearchProps}
        hideCreate
        hideEdit
        // hideShow
      />
    </List>
  );
};
